// extracted by css-extract-rspack-plugin
export default {"navbar":"navbar--JjkkretbV4kSGWr1"};